import PrivacyPolicy from './privacy-policy.vue'

export default PrivacyPolicy